module.exports = __webpack_public_path__ + "static/media/start-conversation.06c9ea71.png";